if (!customElements.get('nido-playwall-showcase')) {
  customElements.define(
    'nido-playwall-showcase',
    class NidoPlaywallShowcase extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-playwall-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-playwall-panel]'));
        this.tabs.forEach((tab) => tab.addEventListener('click', () => this.activate(tab)));
        this.querySelectorAll('[data-playwall-video-trigger]').forEach((trigger) => {
          trigger.addEventListener('click', () => this.playVideo(trigger));
        });
      }

      playVideo(trigger) {
        const panel = trigger.closest('[data-playwall-panel]');
        const video = panel?.querySelector('video');
        if (!video) return;

        trigger.hidden = true;
        video.hidden = false;
        video.muted = false;
        video.volume = 1;
        video.play().catch(() => {});
      }

      activate(activeTab) {
        const id = activeTab.dataset.playwallTab;
        this.tabs.forEach((tab) => {
          const active = tab === activeTab;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
        });
        this.panels.forEach((panel) => {
          const active = panel.dataset.playwallPanel === id;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
          const video = panel.querySelector('video');
          if (!video) return;
          video.pause();
          video.currentTime = 0;
          video.hidden = true;
          const poster = panel.querySelector('[data-playwall-video-trigger]');
          if (poster) poster.hidden = false;
        });
      }
    }
  );
}
